// extracted by mini-css-extract-plugin
export default {"backdrop":"Spinner_backdrop__-bl1c","spinnerContainer":"Spinner_spinnerContainer__fslzo","loader":"Spinner_loader__FSQEU","load8":"Spinner_load8__AO10E"};